import { takeEvery, call, put } from "redux-saga/effects";
import {
  PARTNER_QUEUE_DELETE_REQUEST,
  partnerQueueDeleted,
  partnerQueueDeleteError,
} from "../../actions/partners";
import deleteQueue from "../../../../../backend/oncall/administration/partners/queues/remove";

const requestDeleteQueue = function*(action) {
  try {
    yield call(deleteQueue, action.payload.partnerId, action.payload.queue);
    yield put(partnerQueueDeleted(action.payload.queue));
  } catch (ignore) {
    yield put(partnerQueueDeleteError(action.payload.queue));
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeEvery(PARTNER_QUEUE_DELETE_REQUEST, requestDeleteQueue);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/partners/request-delete-queue.js